import { Box } from '@factorialco/deprecated-design-system'
import { WorkScheduleScheduleFragment } from 'generated/resources/graphql'

import { Controls, InfiniteLoader } from 'modules/core/hooks/usePaginatedQuery'

import WorkScheduleTable from './WorkScheduleTable'

interface Props {
  schedules: WorkScheduleScheduleFragment[]
  controls: Controls
  archived?: boolean
  canAssignEmployees: boolean
  hasFixedWorkSchedulesEnabled: boolean
}

const PaginatedSchedulesList = ({
  schedules,
  controls,
  archived,
  canAssignEmployees,
  hasFixedWorkSchedulesEnabled,
}: Props) => {
  return (
    <Box
      data-scroll-container
      width="full"
      overflowY="auto"
      style={{ maxHeight: 'calc(100vh - 215px)' }}
    >
      <InfiniteLoader controls={controls}>
        <Box gap="s16">
          {schedules.map((schedule) => (
            <Box key={schedule.id}>
              <WorkScheduleTable
                schedule={schedule}
                archived={archived}
                canAssignEmployees={canAssignEmployees}
                hasFixedWorkSchedulesEnabled={hasFixedWorkSchedulesEnabled}
              />
            </Box>
          ))}
        </Box>
      </InfiniteLoader>
    </Box>
  )
}

export default PaginatedSchedulesList
